import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import { colors } from '../../constants/styleConstants';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    background: 'none',
    border: 'none',
  },
  icon: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    border: '1px solid #ebebeb;',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: colors.darkerGray,
    },
    margin: 'auto',
  },
  iconContainer: {
    margin: 'auto',
    maxWidth: 18,
    maxHeight: 18,
    '& svg': {
      maxHeight: '100%',
      maxWidth: '100%',
      height: 'initial !important',
    },
  },
  text: { margin: 'auto', marginLeft: 7, fontFamily: 'Roboto', fontSize: 12, color: '#575757', cursor: 'pointer' },
  hideSm: {
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
}));

const CircleButton = ({ className, icon, text, hideTextOnXS, onClick }) => {
  const classes = useStyles();

  return (
    <button type="button" className={cn(classes.root, className)} onClick={onClick}>
      <div className={classes.icon}>
        <div className={classes.iconContainer}>{icon}</div>
      </div>
      <div className={cn(classes.text, { [classes.hideSm]: hideTextOnXS })}>{text}</div>
    </button>
  );
};

CircleButton.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  text: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  hideTextOnXS: PropTypes.bool,
};

CircleButton.defaultProps = {
  hideTextOnXS: true,
};

export default CircleButton;
